/**
 * Opens the "discount applied" popup once per session, for visitors who arrived through a
 * /discount/CODE link.
 *
 * Two signals are checked, because neither covers every case on its own: Shopify sets a
 * discount_code cookie on the landing request but drops it on later navigation, while the cart
 * only reports the code through Liquid once there's something in it.
 */
(() => {
  const STORAGE_KEY = 'td:discount-popup-seen';

  const readSeen = () => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  };

  const markSeen = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // sessionStorage unavailable (e.g. private browsing)
    }
  };

  const hasDiscountCookie = () =>
    document.cookie.split('; ').some((cookie) => cookie.startsWith('discount_code='));

  const open = async () => {
    if (window.Shopify?.designMode || readSeen()) return;

    const popup = document.querySelector('[data-td-discount-popup]');
    if (!popup) return;

    if (!popup.hasAttribute('data-cart-has-discount') && !hasDiscountCookie()) return;

    await customElements.whenDefined('x-modal');

    markSeen();
    popup.show();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', open);
  } else {
    open();
  }
})();
